export default {
    props: ['color'],
};
